import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCountry32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconCountry32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16 26a10 10 0 0 0 3-.458V23.5h-1a4 4 0 0 1-4-4v-4.088l.514-.286L23 10.412V9q0-.068.009-.133A10 10 0 0 0 19.5 6.63v3.988l-.553.277-2 1-.563.282-.498-.387L13 9.545v2.864a4 4 0 0 1-4 4H6.008C6.223 21.742 10.614 26 16 26M6.126 14.41H9a2 2 0 0 0 2-2V7.337a10 10 0 0 0-4.874 7.071m6.38-7.783.108.084 4.002 3.113.884-.442V6.11a10.1 10.1 0 0 0-4.993.515M21 22.5v2.162A10 10 0 0 0 26 16a9.96 9.96 0 0 0-1.018-4.401l-.496.275L16 16.588V19.5a2 2 0 0 0 2 2h3zM16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCountry32);
